import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { Division } from '@damofire/data-stas';
import { ObservableSavedSearchService, SavedSearch, SavedSearchService } from '@damofire/data-watson';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PreventDefaultDirective } from '../../directive/prevent-default.directive';
import { DialogService } from '../../popup/dialog-service/dialog.service';
import { SnackService } from '../../snack.service';
import { SaveSearchActionComponent } from '../save-search-action/save-search-action.component';

@Component({
  selector: 'app-saved-search-menu',
  templateUrl: './saved-search-menu.component.html',
  styleUrls: ['./saved-search-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatMenuModule, PreventDefaultDirective, SaveSearchActionComponent, TranslatePipe],
})
export class SavedSearchMenuComponent implements OnInit {
  @Input()
  division: Division;

  @Input()
  caretDirection: 'right' | 'down' = 'right';

  @Input()
  iconWithButton = false;

  @Input()
  savedSearch: SavedSearch = null;

  @ViewChild('menuTrigger')
  searchesMenuTrigger: MatMenuTrigger;

  private savedSearchSub: Subscription;
  savedSearches: SavedSearch[] = [];

  constructor(
    private readonly observableSavedSearchService: ObservableSavedSearchService,
    private readonly savedSearchService: SavedSearchService,
    private readonly snackService: SnackService,
    private readonly dialogService: DialogService,
  ) {}

  ngOnInit(): void {
    this.savedSearchSub?.unsubscribe();
    this.savedSearchSub = this.observableSavedSearchService.list(this.division._id).subscribe((ss: SavedSearch[]) => (this.savedSearches = ss));
  }

  openMenu(event: Event): void {
    this.searchesMenuTrigger?._handleClick(event as MouseEvent);
  }

  async delete(savedSearch: SavedSearch): Promise<void> {
    const confirmed = await this.dialogService.showDelete();
    if (confirmed) {
      await this.savedSearchService.delete(savedSearch.division?._id, savedSearch._id);
      this.snackService.snackThis(`commons.messages.delete.success`, savedSearch);
    }
  }
}
